
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.6 2a.4.4 0 01.8 0v11.6H14a.4.4 0 010 .8H1.6V2z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.4 4.4c0-.22.18-.4.4-.4h2.8v2.8a.4.4 0 01-.8 0V5.366l-3.6 3.6-1.6-1.6-2.917 2.917a.4.4 0 01-.566-.566L7.6 6.234l1.6 1.6L12.234 4.8H10.8a.4.4 0 01-.4-.4z","fill":"currentColor"}})])
          )
        }
      }
    